import { ChangeEvent, InputHTMLAttributes, ReactNode } from 'react';
import classNames from 'classnames';

import { NewTickIcon } from '@com/icons';
import { colors } from '@configs/Theme';

export interface RadioProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  label?: string;
  subLable?: string;
  labelClassName?: string;
  subLabelClassName?: string;
  handleChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  value?: string | number;
  checked: boolean;
  icon?: ReactNode;
  inputClassName?: string;
  boxClassName?: string;
  name?: string;
  inputRef?: React.MutableRefObject<HTMLInputElement>;
}

export const Radio = ({
  id,
  name,
  label,
  subLable,
  value,
  checked,
  icon,
  className,
  labelClassName,
  subLabelClassName,
  inputClassName,
  boxClassName,
  inputRef,
  handleChange,
  ...rest
}: RadioProps) => {
  return (
    <div
      className={classNames(
        'relative w-full flex h-6 items-start justify-start overflow-hidden',
        (label || subLable) && 'gap-x-[21px] h-max',
        className,
      )}
    >
      {label && (
        <div
          className={classNames(
            'flex flex-col justify-center order-2',
            subLable && 'gap-y-2',
          )}
        >
          <label
            className={classNames(
              'text-xs font-semibold text-grey-1000  cursor-pointer',
              labelClassName,
            )}
            htmlFor={id}
          >
            {label}
          </label>

          {subLable && (
            <p className={classNames('text-2xs font-light', subLabelClassName)}>
              {subLable}
            </p>
          )}
        </div>
      )}
      <input
        id={id ? id : name}
        type="radio"
        name={name}
        value={value}
        ref={inputRef}
        checked={checked}
        onClick={() => {
          return;
        }}
        onChange={(event: any) => {
          if (handleChange) { handleChange(event) }
        }}
        className={classNames(
          'appearance-none w-[20px] h-[20px] rounded-full bordercursor-pointer',
          inputClassName,
          rest?.disabled && 'opacity-60',
        )}
        {...rest}
      />
      {!checked && (
        <span
          className={classNames(
            'pointer-events-none absolute right-0 top-0 bg-surface-primary border border-content-secondary transition-all flex justify-center items-center z-10 h-[20px] w-[20px] rounded-full  ',
            boxClassName,
            rest?.disabled && 'opacity-60',
          )}
        />
      )}
      {checked && (
        <span
          className={classNames(
            'pointer-events-none absolute right-0 top-0 bg-surface-inverse-primary transition-all flex justify-center items-center z-10 h-[20px] w-[20px] rounded-full  ',
            boxClassName,
            rest?.disabled && 'opacity-60',
          )}
        >
          {icon ? (
            icon
          ) : (
            <NewTickIcon width={12} height={9} stroke={colors.white} />
          )}
        </span>
      )}
    </div>
  );
};
